export const CAMPAIGN_STATUS = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    ARCHIVED: 'archived',
};
export const CAMPAIGN_STATUS_VALUES = Object.values(CAMPAIGN_STATUS);
export const CAMPAIGN_VERTICAL = {
    CASINO: 'casino',
    BETTING: 'betting',
    CRYPTO: 'crypto',
    OTHER: 'other',
};
export const CAMPAIGN_VERTICAL_VALUES = Object.values(CAMPAIGN_VERTICAL);
//# sourceMappingURL=campaign.js.map